<template>
    <div class="temp-loader-container" id="temp-loading-bg">
        <div class="temp-svg-container">
            <DecastAnimatedLogo />
        </div>
    </div>
    <!-- <div class="flex flex-col justify-start items-center relative bg-dark-black">
        <div class="absolute w-full h-fit flex justify-start items-start z-0 top-0">
            <svg class="top-0 absolute w-full h-fit" width="1440" height="844" viewBox="0 0 1440 844" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <rect opacity="0.3" width="1440" height="843.75" transform="matrix(1 0 0 -1 0 843.75)"
                    fill="url(#paint0_radial_474_919)" />
                <defs>
                    <radialGradient id="paint0_radial_474_919" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"
                        gradientTransform="translate(720 843.75) scale(1109.2 1109.2)">
                        <stop stop-color="#D7DF23" stop-opacity="0.5" />
                        <stop offset="0.7" stop-opacity="0" />
                    </radialGradient>
                </defs>
            </svg>
        </div>

        <Navbar />


        <section class="flex flex-col justify-center items-center pt-6 z-10">


            <div class="w-full h-32 relative flex justify-center items-center px-4 mb-8">
                <svg width="436" height="45" viewBox="0 0 436 45" fill="none" xmlns="http://www.w3.org/2000/svg"
                    class="w-full h-14 object-contain">
                    <rect x="0.5" y="1.25" width="435" height="43" rx="7.5" stroke="white" stroke-opacity="0.2" />
                    <path
                        d="M14.93 26.75V19.45H17C17.6667 19.45 18.1867 19.6167 18.56 19.95C18.94 20.2833 19.13 20.7467 19.13 21.34C19.13 21.6733 19.06 21.9633 18.92 22.21C18.78 22.4567 18.58 22.6467 18.32 22.78C18.0667 22.9133 17.76 22.9767 17.4 22.97V22.82C17.7867 22.8133 18.12 22.8867 18.4 23.04C18.6867 23.1933 18.9067 23.4133 19.06 23.7C19.22 23.9867 19.3 24.3267 19.3 24.72C19.3 25.1333 19.2133 25.4933 19.04 25.8C18.8667 26.1067 18.62 26.3433 18.3 26.51C17.98 26.67 17.5967 26.75 17.15 26.75H14.93ZM15.81 25.94H17.05C17.47 25.94 17.8 25.83 18.04 25.61C18.2867 25.3833 18.41 25.0767 18.41 24.69C18.41 24.29 18.2867 23.9667 18.04 23.72C17.8 23.4667 17.47 23.34 17.05 23.34H15.81V25.94ZM15.81 22.56H16.99C17.3767 22.56 17.68 22.4567 17.9 22.25C18.1267 22.0433 18.24 21.7633 18.24 21.41C18.24 21.0567 18.13 20.7767 17.91 20.57C17.69 20.3633 17.3867 20.26 17 20.26H15.81V22.56ZM20.9061 26.75V21.25H21.7861V22.3H21.9961L21.7061 22.95C21.7061 22.3567 21.8328 21.91 22.0861 21.61C22.3461 21.3033 22.7294 21.15 23.2361 21.15C23.8161 21.15 24.2761 21.3333 24.6161 21.7C24.9628 22.06 25.1361 22.55 25.1361 23.17V23.5H24.2361V23.25C24.2361 22.8167 24.1294 22.4867 23.9161 22.26C23.7094 22.0267 23.4128 21.91 23.0261 21.91C22.6461 21.91 22.3461 22.0267 22.1261 22.26C21.9128 22.4933 21.8061 22.8233 21.8061 23.25V26.75H20.9061ZM28.5922 26.83C28.1522 26.83 27.7722 26.7467 27.4522 26.58C27.1322 26.4133 26.8822 26.1733 26.7022 25.86C26.5289 25.54 26.4422 25.1633 26.4422 24.73V23.27C26.4422 22.83 26.5289 22.4533 26.7022 22.14C26.8822 21.8267 27.1322 21.5867 27.4522 21.42C27.7722 21.2533 28.1522 21.17 28.5922 21.17C29.0322 21.17 29.4122 21.2533 29.7322 21.42C30.0522 21.5867 30.2989 21.8267 30.4722 22.14C30.6522 22.4533 30.7422 22.8267 30.7422 23.26V24.73C30.7422 25.1633 30.6522 25.54 30.4722 25.86C30.2989 26.1733 30.0522 26.4133 29.7322 26.58C29.4122 26.7467 29.0322 26.83 28.5922 26.83ZM28.5922 26.03C28.9855 26.03 29.2922 25.92 29.5122 25.7C29.7322 25.48 29.8422 25.1567 29.8422 24.73V23.27C29.8422 22.8433 29.7322 22.52 29.5122 22.3C29.2922 22.08 28.9855 21.97 28.5922 21.97C28.2055 21.97 27.8989 22.08 27.6722 22.3C27.4522 22.52 27.3422 22.8433 27.3422 23.27V24.73C27.3422 25.1567 27.4522 25.48 27.6722 25.7C27.8989 25.92 28.2055 26.03 28.5922 26.03ZM33.9083 26.85C33.3283 26.85 32.8716 26.7033 32.5383 26.41C32.2049 26.11 32.0383 25.7067 32.0383 25.2C32.0383 24.6867 32.2049 24.2833 32.5383 23.99C32.8716 23.6967 33.3216 23.55 33.8883 23.55H35.5883V23C35.5883 22.66 35.4849 22.4 35.2783 22.22C35.0783 22.0333 34.7916 21.94 34.4183 21.94C34.0916 21.94 33.8183 22.01 33.5983 22.15C33.3783 22.2833 33.2516 22.4667 33.2183 22.7H32.3183C32.3783 22.2267 32.6016 21.85 32.9883 21.57C33.3749 21.29 33.8583 21.15 34.4383 21.15C35.0716 21.15 35.5716 21.3133 35.9383 21.64C36.3049 21.9667 36.4883 22.41 36.4883 22.97V26.75H35.6083V25.7H35.4583L35.6083 25.55C35.6083 25.95 35.4516 26.2667 35.1383 26.5C34.8316 26.7333 34.4216 26.85 33.9083 26.85ZM34.1283 26.14C34.5549 26.14 34.9049 26.0333 35.1783 25.82C35.4516 25.6067 35.5883 25.3333 35.5883 25V24.22H33.9083C33.6083 24.22 33.3716 24.3033 33.1983 24.47C33.0249 24.6367 32.9383 24.8633 32.9383 25.15C32.9383 25.4567 33.0416 25.7 33.2483 25.88C33.4616 26.0533 33.7549 26.14 34.1283 26.14ZM39.8644 26.85C39.3177 26.85 38.8744 26.6667 38.5344 26.3C38.201 25.9333 38.0344 25.4367 38.0344 24.81V23.2C38.0344 22.5667 38.201 22.0667 38.5344 21.7C38.8677 21.3333 39.311 21.15 39.8644 21.15C40.3177 21.15 40.681 21.2733 40.9544 21.52C41.2277 21.7667 41.3644 22.0967 41.3644 22.51L41.1844 22.3H41.3844L41.3644 21.05V19.45H42.2644V26.75H41.3644V25.7H41.1844L41.3644 25.49C41.3644 25.91 41.2277 26.2433 40.9544 26.49C40.681 26.73 40.3177 26.85 39.8644 26.85ZM40.1644 26.07C40.5377 26.07 40.831 25.9533 41.0444 25.72C41.2577 25.4867 41.3644 25.1633 41.3644 24.75V23.25C41.3644 22.8367 41.2577 22.5133 41.0444 22.28C40.831 22.0467 40.5377 21.93 40.1644 21.93C39.7844 21.93 39.4844 22.0433 39.2644 22.27C39.0444 22.4967 38.9344 22.8233 38.9344 23.25V24.75C38.9344 25.1767 39.0444 25.5033 39.2644 25.73C39.4844 25.9567 39.7844 26.07 40.1644 26.07ZM46.0205 26.85C45.5805 26.85 45.1938 26.7667 44.8605 26.6C44.5338 26.4333 44.2805 26.1933 44.1005 25.88C43.9205 25.56 43.8305 25.1833 43.8305 24.75V23.25C43.8305 22.81 43.9205 22.4333 44.1005 22.12C44.2805 21.8067 44.5338 21.5667 44.8605 21.4C45.1938 21.2333 45.5805 21.15 46.0205 21.15C46.6538 21.15 47.1638 21.32 47.5505 21.66C47.9371 22 48.1405 22.4633 48.1605 23.05H47.2605C47.2405 22.6967 47.1205 22.4267 46.9005 22.24C46.6871 22.0467 46.3938 21.95 46.0205 21.95C45.6271 21.95 45.3138 22.0633 45.0805 22.29C44.8471 22.51 44.7305 22.8267 44.7305 23.24V24.75C44.7305 25.1633 44.8471 25.4833 45.0805 25.71C45.3138 25.9367 45.6271 26.05 46.0205 26.05C46.3938 26.05 46.6871 25.9533 46.9005 25.76C47.1205 25.5667 47.2405 25.2967 47.2605 24.95H48.1605C48.1405 25.5367 47.9371 26 47.5505 26.34C47.1638 26.68 46.6538 26.85 46.0205 26.85ZM51.2966 26.85C50.7166 26.85 50.2599 26.7033 49.9266 26.41C49.5932 26.11 49.4266 25.7067 49.4266 25.2C49.4266 24.6867 49.5932 24.2833 49.9266 23.99C50.2599 23.6967 50.7099 23.55 51.2766 23.55H52.9766V23C52.9766 22.66 52.8732 22.4 52.6666 22.22C52.4666 22.0333 52.1799 21.94 51.8066 21.94C51.4799 21.94 51.2066 22.01 50.9866 22.15C50.7666 22.2833 50.6399 22.4667 50.6066 22.7H49.7066C49.7666 22.2267 49.9899 21.85 50.3766 21.57C50.7632 21.29 51.2466 21.15 51.8266 21.15C52.4599 21.15 52.9599 21.3133 53.3266 21.64C53.6932 21.9667 53.8766 22.41 53.8766 22.97V26.75H52.9966V25.7H52.8466L52.9966 25.55C52.9966 25.95 52.8399 26.2667 52.5266 26.5C52.2199 26.7333 51.8099 26.85 51.2966 26.85ZM51.5166 26.14C51.9432 26.14 52.2932 26.0333 52.5666 25.82C52.8399 25.6067 52.9766 25.3333 52.9766 25V24.22H51.2966C50.9966 24.22 50.7599 24.3033 50.5866 24.47C50.4132 24.6367 50.3266 24.8633 50.3266 25.15C50.3266 25.4567 50.4299 25.7 50.6366 25.88C50.8499 26.0533 51.1432 26.14 51.5166 26.14ZM57.4027 26.83C57.0293 26.83 56.7027 26.7733 56.4227 26.66C56.1493 26.54 55.9293 26.3733 55.7627 26.16C55.6027 25.9467 55.506 25.6933 55.4727 25.4H56.3727C56.4127 25.5933 56.5193 25.7467 56.6927 25.86C56.8727 25.9733 57.1093 26.03 57.4027 26.03H57.8227C58.176 26.03 58.4393 25.96 58.6127 25.82C58.786 25.6733 58.8727 25.48 58.8727 25.24C58.8727 25.0067 58.7927 24.8233 58.6327 24.69C58.4793 24.55 58.2493 24.4567 57.9427 24.41L57.2027 24.29C56.6627 24.1967 56.2593 24.03 55.9927 23.79C55.7327 23.5433 55.6027 23.1867 55.6027 22.72C55.6027 22.2267 55.7593 21.8467 56.0727 21.58C56.386 21.3067 56.856 21.17 57.4827 21.17H57.8627C58.3893 21.17 58.8127 21.2933 59.1327 21.54C59.4527 21.7867 59.646 22.12 59.7127 22.54H58.8127C58.7727 22.3667 58.6727 22.23 58.5127 22.13C58.3527 22.0233 58.136 21.97 57.8627 21.97H57.4827C57.1427 21.97 56.8927 22.0333 56.7327 22.16C56.5793 22.2867 56.5027 22.4767 56.5027 22.73C56.5027 22.9567 56.5693 23.1233 56.7027 23.23C56.836 23.3367 57.046 23.4133 57.3327 23.46L58.0727 23.58C58.666 23.6733 59.096 23.8467 59.3627 24.1C59.636 24.3533 59.7727 24.72 59.7727 25.2C59.7727 25.7067 59.6093 26.1067 59.2827 26.4C58.9627 26.6867 58.476 26.83 57.8227 26.83H57.4027ZM63.9688 26.75C63.4954 26.75 63.1254 26.6233 62.8588 26.37C62.5988 26.1167 62.4688 25.76 62.4688 25.3V22.07H60.9188V21.25H62.4688V19.7H63.3688V21.25H65.5688V22.07H63.3688V25.3C63.3688 25.72 63.5688 25.93 63.9688 25.93H65.4688V26.75H63.9688ZM73.1109 26.75V19.45H74.0109V25.93H77.3109V26.75H73.1109ZM78.607 26.75V25.93H80.557V22.07H78.857V21.25H81.457V25.93H83.307V26.75H78.607ZM80.907 20.26C80.687 20.26 80.5137 20.2033 80.387 20.09C80.2604 19.9767 80.197 19.8233 80.197 19.63C80.197 19.43 80.2604 19.2733 80.387 19.16C80.5137 19.04 80.687 18.98 80.907 18.98C81.127 18.98 81.3004 19.04 81.427 19.16C81.5537 19.2733 81.617 19.43 81.617 19.63C81.617 19.8233 81.5537 19.9767 81.427 20.09C81.3004 20.2033 81.127 20.26 80.907 20.26ZM85.9431 26.75L84.1031 21.25H85.0231L86.2431 24.95C86.3165 25.17 86.3831 25.3833 86.4431 25.59C86.5031 25.79 86.5465 25.9467 86.5731 26.06C86.6065 25.9467 86.6531 25.79 86.7131 25.59C86.7731 25.3833 86.8365 25.17 86.9031 24.95L88.0931 21.25H89.0031L87.1631 26.75H85.9431ZM92.3492 26.85C91.9159 26.85 91.5359 26.7633 91.2092 26.59C90.8892 26.4167 90.6392 26.1733 90.4592 25.86C90.2859 25.54 90.1992 25.17 90.1992 24.75V23.25C90.1992 22.8233 90.2859 22.4533 90.4592 22.14C90.6392 21.8267 90.8892 21.5833 91.2092 21.41C91.5359 21.2367 91.9159 21.15 92.3492 21.15C92.7826 21.15 93.1592 21.2367 93.4792 21.41C93.8059 21.5833 94.0559 21.8267 94.2292 22.14C94.4092 22.4533 94.4992 22.8233 94.4992 23.25V24.22H91.0792V24.75C91.0792 25.1833 91.1892 25.5167 91.4092 25.75C91.6292 25.9767 91.9426 26.09 92.3492 26.09C92.6959 26.09 92.9759 26.03 93.1892 25.91C93.4026 25.7833 93.5326 25.5967 93.5792 25.35H94.4792C94.4192 25.81 94.1926 26.1767 93.7992 26.45C93.4126 26.7167 92.9292 26.85 92.3492 26.85ZM93.6192 23.62V23.25C93.6192 22.8167 93.5092 22.4833 93.2892 22.25C93.0759 22.0167 92.7626 21.9 92.3492 21.9C91.9426 21.9 91.6292 22.0167 91.4092 22.25C91.1892 22.4833 91.0792 22.8167 91.0792 23.25V23.54H93.6892L93.6192 23.62ZM102.171 26.75L101.291 21.25H102.091L102.641 25.15C102.661 25.2967 102.681 25.4567 102.701 25.63C102.728 25.7967 102.748 25.9367 102.761 26.05C102.775 25.9367 102.795 25.7967 102.821 25.63C102.855 25.4567 102.881 25.2967 102.901 25.15L103.511 21.25H104.371L104.981 25.15C105.001 25.2967 105.025 25.4567 105.051 25.63C105.085 25.7967 105.108 25.9367 105.121 26.05C105.135 25.9367 105.155 25.7967 105.181 25.63C105.215 25.4567 105.241 25.2967 105.261 25.15L105.831 21.25H106.591L105.671 26.75H104.681L104.091 22.95C104.065 22.7633 104.035 22.5767 104.001 22.39C103.968 22.2033 103.945 22.0567 103.931 21.95C103.918 22.0567 103.898 22.2033 103.871 22.39C103.845 22.5767 103.815 22.7633 103.781 22.95L103.161 26.75H102.171ZM107.588 26.75V25.93H109.538V22.07H107.838V21.25H110.438V25.93H112.288V26.75H107.588ZM109.888 20.26C109.668 20.26 109.494 20.2033 109.368 20.09C109.241 19.9767 109.178 19.8233 109.178 19.63C109.178 19.43 109.241 19.2733 109.368 19.16C109.494 19.04 109.668 18.98 109.888 18.98C110.108 18.98 110.281 19.04 110.408 19.16C110.534 19.2733 110.598 19.43 110.598 19.63C110.598 19.8233 110.534 19.9767 110.408 20.09C110.281 20.2033 110.108 20.26 109.888 20.26ZM116.134 26.75C115.66 26.75 115.29 26.6233 115.024 26.37C114.764 26.1167 114.634 25.76 114.634 25.3V22.07H113.084V21.25H114.634V19.7H115.534V21.25H117.734V22.07H115.534V25.3C115.534 25.72 115.734 25.93 116.134 25.93H117.634V26.75H116.134ZM119.25 26.75V19.45H120.15V21.25V22.3H120.34L120.15 22.51C120.15 22.0767 120.28 21.7433 120.54 21.51C120.8 21.27 121.16 21.15 121.62 21.15C122.173 21.15 122.613 21.32 122.94 21.66C123.266 22 123.43 22.4633 123.43 23.05V26.75H122.53V23.15C122.53 22.7567 122.423 22.4533 122.21 22.24C122.003 22.02 121.72 21.91 121.36 21.91C120.986 21.91 120.69 22.0267 120.47 22.26C120.256 22.4933 120.15 22.8233 120.15 23.25V26.75H119.25ZM132.922 26.85C132.489 26.85 132.109 26.7633 131.782 26.59C131.462 26.4167 131.212 26.1733 131.032 25.86C130.859 25.54 130.772 25.17 130.772 24.75V23.25C130.772 22.8233 130.859 22.4533 131.032 22.14C131.212 21.8267 131.462 21.5833 131.782 21.41C132.109 21.2367 132.489 21.15 132.922 21.15C133.355 21.15 133.732 21.2367 134.052 21.41C134.379 21.5833 134.629 21.8267 134.802 22.14C134.982 22.4533 135.072 22.8233 135.072 23.25V24.22H131.652V24.75C131.652 25.1833 131.762 25.5167 131.982 25.75C132.202 25.9767 132.515 26.09 132.922 26.09C133.269 26.09 133.549 26.03 133.762 25.91C133.975 25.7833 134.105 25.5967 134.152 25.35H135.052C134.992 25.81 134.765 26.1767 134.372 26.45C133.985 26.7167 133.502 26.85 132.922 26.85ZM134.192 23.62V23.25C134.192 22.8167 134.082 22.4833 133.862 22.25C133.649 22.0167 133.335 21.9 132.922 21.9C132.515 21.9 132.202 22.0167 131.982 22.25C131.762 22.4833 131.652 22.8167 131.652 23.25V23.54H134.262L134.192 23.62ZM138.238 26.85C137.658 26.85 137.201 26.7033 136.868 26.41C136.535 26.11 136.368 25.7067 136.368 25.2C136.368 24.6867 136.535 24.2833 136.868 23.99C137.201 23.6967 137.651 23.55 138.218 23.55H139.918V23C139.918 22.66 139.815 22.4 139.608 22.22C139.408 22.0333 139.121 21.94 138.748 21.94C138.421 21.94 138.148 22.01 137.928 22.15C137.708 22.2833 137.581 22.4667 137.548 22.7H136.648C136.708 22.2267 136.931 21.85 137.318 21.57C137.705 21.29 138.188 21.15 138.768 21.15C139.401 21.15 139.901 21.3133 140.268 21.64C140.635 21.9667 140.818 22.41 140.818 22.97V26.75H139.938V25.7H139.788L139.938 25.55C139.938 25.95 139.781 26.2667 139.468 26.5C139.161 26.7333 138.751 26.85 138.238 26.85ZM138.458 26.14C138.885 26.14 139.235 26.0333 139.508 25.82C139.781 25.6067 139.918 25.3333 139.918 25V24.22H138.238C137.938 24.22 137.701 24.3033 137.528 24.47C137.355 24.6367 137.268 24.8633 137.268 25.15C137.268 25.4567 137.371 25.7 137.578 25.88C137.791 26.0533 138.085 26.14 138.458 26.14ZM144.344 26.83C143.971 26.83 143.644 26.7733 143.364 26.66C143.091 26.54 142.871 26.3733 142.704 26.16C142.544 25.9467 142.447 25.6933 142.414 25.4H143.314C143.354 25.5933 143.461 25.7467 143.634 25.86C143.814 25.9733 144.051 26.03 144.344 26.03H144.764C145.117 26.03 145.381 25.96 145.554 25.82C145.727 25.6733 145.814 25.48 145.814 25.24C145.814 25.0067 145.734 24.8233 145.574 24.69C145.421 24.55 145.191 24.4567 144.884 24.41L144.144 24.29C143.604 24.1967 143.201 24.03 142.934 23.79C142.674 23.5433 142.544 23.1867 142.544 22.72C142.544 22.2267 142.701 21.8467 143.014 21.58C143.327 21.3067 143.797 21.17 144.424 21.17H144.804C145.331 21.17 145.754 21.2933 146.074 21.54C146.394 21.7867 146.587 22.12 146.654 22.54H145.754C145.714 22.3667 145.614 22.23 145.454 22.13C145.294 22.0233 145.077 21.97 144.804 21.97H144.424C144.084 21.97 143.834 22.0333 143.674 22.16C143.521 22.2867 143.444 22.4767 143.444 22.73C143.444 22.9567 143.511 23.1233 143.644 23.23C143.777 23.3367 143.987 23.4133 144.274 23.46L145.014 23.58C145.607 23.6733 146.037 23.8467 146.304 24.1C146.577 24.3533 146.714 24.72 146.714 25.2C146.714 25.7067 146.551 26.1067 146.224 26.4C145.904 26.6867 145.417 26.83 144.764 26.83H144.344ZM150.31 26.85C149.877 26.85 149.497 26.7633 149.17 26.59C148.85 26.4167 148.6 26.1733 148.42 25.86C148.247 25.54 148.16 25.17 148.16 24.75V23.25C148.16 22.8233 148.247 22.4533 148.42 22.14C148.6 21.8267 148.85 21.5833 149.17 21.41C149.497 21.2367 149.877 21.15 150.31 21.15C150.743 21.15 151.12 21.2367 151.44 21.41C151.767 21.5833 152.017 21.8267 152.19 22.14C152.37 22.4533 152.46 22.8233 152.46 23.25V24.22H149.04V24.75C149.04 25.1833 149.15 25.5167 149.37 25.75C149.59 25.9767 149.903 26.09 150.31 26.09C150.657 26.09 150.937 26.03 151.15 25.91C151.363 25.7833 151.493 25.5967 151.54 25.35H152.44C152.38 25.81 152.153 26.1767 151.76 26.45C151.373 26.7167 150.89 26.85 150.31 26.85ZM151.58 23.62V23.25C151.58 22.8167 151.47 22.4833 151.25 22.25C151.037 22.0167 150.723 21.9 150.31 21.9C149.903 21.9 149.59 22.0167 149.37 22.25C149.15 22.4833 149.04 22.8167 149.04 23.25V23.54H151.65L151.58 23.62ZM161.452 27.85V18.45H162.352V27.85H161.452Z"
                        fill="white" />
                    <path
                        d="M183 28.4167C184.206 28.4167 185.363 28.2973 186.435 28.0787C187.775 27.8053 188.444 27.6693 189.055 26.884C189.666 26.098 189.666 25.196 189.666 23.392V22.108C189.666 20.304 189.666 19.4013 189.055 18.616C188.444 17.8307 187.775 17.694 186.435 17.4213C185.304 17.1946 184.153 17.0814 183 17.0833C181.793 17.0833 180.636 17.2027 179.564 17.4213C178.224 17.6947 177.555 17.8307 176.944 18.616C176.333 19.402 176.333 20.304 176.333 22.108V23.392C176.333 25.196 176.333 26.0987 176.944 26.884C177.555 27.6693 178.224 27.806 179.564 28.0787C180.636 28.2973 181.793 28.4167 183 28.4167Z"
                        stroke="#FF5151" stroke-linecap="round" stroke-linejoin="round" />
                    <path
                        d="M185.641 22.9587C185.543 23.3627 185.016 23.652 183.963 24.2327C182.818 24.864 182.245 25.1793 181.782 25.0573C181.628 25.0175 181.483 24.9455 181.359 24.846C181 24.556 181 23.954 181 22.75C181 21.546 181 20.944 181.359 20.654C181.48 20.556 181.625 20.4833 181.782 20.4427C182.245 20.3207 182.818 20.636 183.963 21.2673C185.017 21.8473 185.543 22.1373 185.641 22.5413C185.675 22.6787 185.675 22.8213 185.641 22.9587Z"
                        stroke="#FF5151" stroke-linecap="round" stroke-linejoin="round" />
                    <path
                        d="M211.667 19.4167V22.0833M209 19.4167V22.0833M211.667 16.75H206.333C205.076 16.75 204.448 16.75 204.057 17.1393C203.667 17.528 203.667 18.154 203.667 19.406V23.79C203.667 24.0367 203.667 24.16 203.683 24.2633C203.728 24.5407 203.859 24.7969 204.058 24.9953C204.257 25.1936 204.514 25.3241 204.791 25.368C204.895 25.384 205.019 25.384 205.267 25.384C205.329 25.384 205.36 25.384 205.385 25.388C205.455 25.3989 205.519 25.4315 205.569 25.481C205.618 25.5306 205.651 25.5946 205.663 25.664C205.667 25.69 205.667 25.7207 205.667 25.7827V26.8113C205.667 27.5993 205.667 27.9933 205.89 28.0713C206.113 28.1493 206.36 27.842 206.854 27.226L208.133 25.6327C208.231 25.5107 208.281 25.4493 208.349 25.4167C208.417 25.384 208.496 25.384 208.654 25.384H211.229C211.774 25.384 212.046 25.384 212.291 25.2827C212.536 25.182 212.729 24.9893 213.115 24.606L213.552 24.1693C213.938 23.786 214.13 23.594 214.232 23.3493C214.333 23.1053 214.333 22.834 214.333 22.2913V19.4067C214.333 18.154 214.333 17.528 213.943 17.1393C213.552 16.75 212.924 16.75 211.667 16.75Z"
                        stroke="#9B94FF" stroke-linecap="round" stroke-linejoin="round" />
                    <path
                        d="M228.667 22.75C228.667 19.7647 228.667 18.2713 229.594 17.344C230.521 16.4167 232.014 16.4167 235 16.4167C237.985 16.4167 239.479 16.4167 240.406 17.344C241.333 18.2713 241.333 19.764 241.333 22.75C241.333 25.7353 241.333 27.2287 240.406 28.156C239.479 29.0833 237.986 29.0833 235 29.0833C232.015 29.0833 230.521 29.0833 229.594 28.156C228.667 27.2287 228.667 25.736 228.667 22.75Z"
                        stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                    <path
                        d="M234.024 22.0887C233.477 22.0113 232.23 22.1387 231.62 23.2687C231.009 24.3987 231.624 25.5747 232.009 26.0213C232.388 26.4393 233.594 27.2307 234.874 26.458C235.191 26.2667 235.586 26.1233 236.034 24.6267L235.982 18.7373C235.896 19.386 236.612 20.9073 238.652 21.0873"
                        stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                    <path
                        d="M255.55 27.85V18.45H256.45V27.85H255.55ZM265.092 26.75L266.992 19.45H268.202L270.092 26.75H269.182L268.702 24.81H266.492L266.012 26.75H265.092ZM266.672 24.05H268.512L267.952 21.8C267.846 21.3733 267.762 21.0167 267.702 20.73C267.642 20.4433 267.606 20.2567 267.592 20.17C267.579 20.2567 267.542 20.4433 267.482 20.73C267.422 21.0167 267.339 21.37 267.232 21.79L266.672 24.05ZM271.438 26.75V25.93H272.928V20.27H271.438V19.45H275.338V20.27H273.848V25.93H275.338V26.75H271.438ZM282.98 26.75V19.45H287.18V20.27H283.87V22.53H286.83V23.34H283.87V25.93H287.18V26.75H282.98ZM288.697 26.75V21.25H289.597V22.3H289.787L289.597 22.51C289.597 22.0767 289.727 21.7433 289.987 21.51C290.247 21.27 290.607 21.15 291.067 21.15C291.62 21.15 292.06 21.32 292.387 21.66C292.713 22 292.877 22.4633 292.877 23.05V26.75H291.977V23.15C291.977 22.7567 291.87 22.4567 291.657 22.25C291.45 22.0367 291.167 21.93 290.807 21.93C290.433 21.93 290.137 22.0433 289.917 22.27C289.703 22.4967 289.597 22.8233 289.597 23.25V26.75H288.697ZM294.493 26.75V19.45H295.393V21.25V22.3H295.583L295.393 22.51C295.393 22.0767 295.523 21.7433 295.783 21.51C296.043 21.27 296.403 21.15 296.863 21.15C297.416 21.15 297.856 21.32 298.183 21.66C298.509 22 298.673 22.4633 298.673 23.05V26.75H297.773V23.15C297.773 22.7567 297.666 22.4533 297.453 22.24C297.246 22.02 296.963 21.91 296.603 21.91C296.229 21.91 295.933 22.0267 295.713 22.26C295.499 22.4933 295.393 22.8233 295.393 23.25V26.75H294.493ZM301.889 26.85C301.309 26.85 300.852 26.7033 300.519 26.41C300.185 26.11 300.019 25.7067 300.019 25.2C300.019 24.6867 300.185 24.2833 300.519 23.99C300.852 23.6967 301.302 23.55 301.869 23.55H303.569V23C303.569 22.66 303.465 22.4 303.259 22.22C303.059 22.0333 302.772 21.94 302.399 21.94C302.072 21.94 301.799 22.01 301.579 22.15C301.359 22.2833 301.232 22.4667 301.199 22.7H300.299C300.359 22.2267 300.582 21.85 300.969 21.57C301.355 21.29 301.839 21.15 302.419 21.15C303.052 21.15 303.552 21.3133 303.919 21.64C304.285 21.9667 304.469 22.41 304.469 22.97V26.75H303.589V25.7H303.439L303.589 25.55C303.589 25.95 303.432 26.2667 303.119 26.5C302.812 26.7333 302.402 26.85 301.889 26.85ZM302.109 26.14C302.535 26.14 302.885 26.0333 303.159 25.82C303.432 25.6067 303.569 25.3333 303.569 25V24.22H301.889C301.589 24.22 301.352 24.3033 301.179 24.47C301.005 24.6367 300.919 24.8633 300.919 25.15C300.919 25.4567 301.022 25.7 301.229 25.88C301.442 26.0533 301.735 26.14 302.109 26.14ZM306.085 26.75V21.25H306.985V22.3H307.175L306.985 22.51C306.985 22.0767 307.115 21.7433 307.375 21.51C307.635 21.27 307.995 21.15 308.455 21.15C309.008 21.15 309.448 21.32 309.775 21.66C310.102 22 310.265 22.4633 310.265 23.05V26.75H309.365V23.15C309.365 22.7567 309.258 22.4567 309.045 22.25C308.838 22.0367 308.555 21.93 308.195 21.93C307.822 21.93 307.525 22.0433 307.305 22.27C307.092 22.4967 306.985 22.8233 306.985 23.25V26.75H306.085ZM314.001 26.85C313.561 26.85 313.174 26.7667 312.841 26.6C312.514 26.4333 312.261 26.1933 312.081 25.88C311.901 25.56 311.811 25.1833 311.811 24.75V23.25C311.811 22.81 311.901 22.4333 312.081 22.12C312.261 21.8067 312.514 21.5667 312.841 21.4C313.174 21.2333 313.561 21.15 314.001 21.15C314.634 21.15 315.144 21.32 315.531 21.66C315.918 22 316.121 22.4633 316.141 23.05H315.241C315.221 22.6967 315.101 22.4267 314.881 22.24C314.668 22.0467 314.374 21.95 314.001 21.95C313.608 21.95 313.294 22.0633 313.061 22.29C312.828 22.51 312.711 22.8267 312.711 23.24V24.75C312.711 25.1633 312.828 25.4833 313.061 25.71C313.294 25.9367 313.608 26.05 314.001 26.05C314.374 26.05 314.668 25.9533 314.881 25.76C315.101 25.5667 315.221 25.2967 315.241 24.95H316.141C316.121 25.5367 315.918 26 315.531 26.34C315.144 26.68 314.634 26.85 314.001 26.85ZM319.757 26.85C319.324 26.85 318.944 26.7633 318.617 26.59C318.297 26.4167 318.047 26.1733 317.867 25.86C317.694 25.54 317.607 25.17 317.607 24.75V23.25C317.607 22.8233 317.694 22.4533 317.867 22.14C318.047 21.8267 318.297 21.5833 318.617 21.41C318.944 21.2367 319.324 21.15 319.757 21.15C320.19 21.15 320.567 21.2367 320.887 21.41C321.214 21.5833 321.464 21.8267 321.637 22.14C321.817 22.4533 321.907 22.8233 321.907 23.25V24.22H318.487V24.75C318.487 25.1833 318.597 25.5167 318.817 25.75C319.037 25.9767 319.35 26.09 319.757 26.09C320.104 26.09 320.384 26.03 320.597 25.91C320.81 25.7833 320.94 25.5967 320.987 25.35H321.887C321.827 25.81 321.6 26.1767 321.207 26.45C320.82 26.7167 320.337 26.85 319.757 26.85ZM321.027 23.62V23.25C321.027 22.8167 320.917 22.4833 320.697 22.25C320.484 22.0167 320.17 21.9 319.757 21.9C319.35 21.9 319.037 22.0167 318.817 22.25C318.597 22.4833 318.487 22.8167 318.487 23.25V23.54H321.097L321.027 23.62ZM325.233 26.85C324.686 26.85 324.243 26.6667 323.903 26.3C323.57 25.9333 323.403 25.4367 323.403 24.81V23.2C323.403 22.5667 323.57 22.0667 323.903 21.7C324.236 21.3333 324.68 21.15 325.233 21.15C325.686 21.15 326.05 21.2733 326.323 21.52C326.596 21.7667 326.733 22.0967 326.733 22.51L326.553 22.3H326.753L326.733 21.05V19.45H327.633V26.75H326.733V25.7H326.553L326.733 25.49C326.733 25.91 326.596 26.2433 326.323 26.49C326.05 26.73 325.686 26.85 325.233 26.85ZM325.533 26.07C325.906 26.07 326.2 25.9533 326.413 25.72C326.626 25.4867 326.733 25.1633 326.733 24.75V23.25C326.733 22.8367 326.626 22.5133 326.413 22.28C326.2 22.0467 325.906 21.93 325.533 21.93C325.153 21.93 324.853 22.0433 324.633 22.27C324.413 22.4967 324.303 22.8233 324.303 23.25V24.75C324.303 25.1767 324.413 25.5033 324.633 25.73C324.853 25.9567 325.153 26.07 325.533 26.07ZM335.065 26.75V19.45H337.415C337.869 19.45 338.262 19.54 338.595 19.72C338.929 19.8933 339.185 20.14 339.365 20.46C339.552 20.78 339.645 21.16 339.645 21.6C339.645 22.0333 339.552 22.4133 339.365 22.74C339.185 23.06 338.929 23.31 338.595 23.49C338.262 23.6633 337.869 23.75 337.415 23.75H335.965V26.75H335.065ZM335.965 22.94H337.415C337.809 22.94 338.122 22.82 338.355 22.58C338.595 22.3333 338.715 22.0067 338.715 21.6C338.715 21.1867 338.595 20.86 338.355 20.62C338.122 20.38 337.809 20.26 337.415 20.26H335.965V22.94ZM342.941 26.83C342.501 26.83 342.121 26.7467 341.801 26.58C341.481 26.4133 341.231 26.1733 341.051 25.86C340.878 25.54 340.791 25.1633 340.791 24.73V23.27C340.791 22.83 340.878 22.4533 341.051 22.14C341.231 21.8267 341.481 21.5867 341.801 21.42C342.121 21.2533 342.501 21.17 342.941 21.17C343.381 21.17 343.761 21.2533 344.081 21.42C344.401 21.5867 344.648 21.8267 344.821 22.14C345.001 22.4533 345.091 22.8267 345.091 23.26V24.73C345.091 25.1633 345.001 25.54 344.821 25.86C344.648 26.1733 344.401 26.4133 344.081 26.58C343.761 26.7467 343.381 26.83 342.941 26.83ZM342.941 26.03C343.335 26.03 343.641 25.92 343.861 25.7C344.081 25.48 344.191 25.1567 344.191 24.73V23.27C344.191 22.8433 344.081 22.52 343.861 22.3C343.641 22.08 343.335 21.97 342.941 21.97C342.555 21.97 342.248 22.08 342.021 22.3C341.801 22.52 341.691 22.8433 341.691 23.27V24.73C341.691 25.1567 341.801 25.48 342.021 25.7C342.248 25.92 342.555 26.03 342.941 26.03ZM348.568 26.83C348.194 26.83 347.868 26.7733 347.588 26.66C347.314 26.54 347.094 26.3733 346.928 26.16C346.768 25.9467 346.671 25.6933 346.638 25.4H347.538C347.578 25.5933 347.684 25.7467 347.858 25.86C348.038 25.9733 348.274 26.03 348.568 26.03H348.988C349.341 26.03 349.604 25.96 349.778 25.82C349.951 25.6733 350.038 25.48 350.038 25.24C350.038 25.0067 349.958 24.8233 349.798 24.69C349.644 24.55 349.414 24.4567 349.108 24.41L348.368 24.29C347.828 24.1967 347.424 24.03 347.158 23.79C346.898 23.5433 346.768 23.1867 346.768 22.72C346.768 22.2267 346.924 21.8467 347.238 21.58C347.551 21.3067 348.021 21.17 348.648 21.17H349.028C349.554 21.17 349.978 21.2933 350.298 21.54C350.618 21.7867 350.811 22.12 350.878 22.54H349.978C349.938 22.3667 349.838 22.23 349.678 22.13C349.518 22.0233 349.301 21.97 349.028 21.97H348.648C348.308 21.97 348.058 22.0333 347.898 22.16C347.744 22.2867 347.668 22.4767 347.668 22.73C347.668 22.9567 347.734 23.1233 347.868 23.23C348.001 23.3367 348.211 23.4133 348.498 23.46L349.238 23.58C349.831 23.6733 350.261 23.8467 350.528 24.1C350.801 24.3533 350.938 24.72 350.938 25.2C350.938 25.7067 350.774 26.1067 350.448 26.4C350.128 26.6867 349.641 26.83 348.988 26.83H348.568ZM355.134 26.75C354.66 26.75 354.29 26.6233 354.024 26.37C353.764 26.1167 353.634 25.76 353.634 25.3V22.07H352.084V21.25H353.634V19.7H354.534V21.25H356.734V22.07H354.534V25.3C354.534 25.72 354.734 25.93 355.134 25.93H356.634V26.75H355.134ZM358.73 23.85V23.05H361.93V23.85H358.73ZM364.046 28.55V21.25H364.946V22.3H365.126L364.946 22.51C364.946 22.09 365.082 21.76 365.356 21.52C365.636 21.2733 366.002 21.15 366.456 21.15C367.009 21.15 367.449 21.3333 367.776 21.7C368.109 22.06 368.276 22.5567 368.276 23.19V24.8C368.276 25.22 368.199 25.5833 368.046 25.89C367.899 26.1967 367.689 26.4333 367.416 26.6C367.149 26.7667 366.829 26.85 366.456 26.85C366.009 26.85 365.646 26.7267 365.366 26.48C365.086 26.2333 364.946 25.9033 364.946 25.49L365.126 25.7H364.926L364.946 26.95V28.55H364.046ZM366.156 26.07C366.536 26.07 366.832 25.9567 367.046 25.73C367.266 25.5033 367.376 25.1767 367.376 24.75V23.25C367.376 22.8233 367.266 22.4967 367.046 22.27C366.832 22.0433 366.536 21.93 366.156 21.93C365.789 21.93 365.496 22.0467 365.276 22.28C365.056 22.5133 364.946 22.8367 364.946 23.25V24.75C364.946 25.1633 365.056 25.4867 365.276 25.72C365.496 25.9533 365.789 26.07 366.156 26.07ZM370.032 26.75V21.25H370.912V22.3H371.122L370.832 22.95C370.832 22.3567 370.959 21.91 371.212 21.61C371.472 21.3033 371.855 21.15 372.362 21.15C372.942 21.15 373.402 21.3333 373.742 21.7C374.089 22.06 374.262 22.55 374.262 23.17V23.5H373.362V23.25C373.362 22.8167 373.255 22.4867 373.042 22.26C372.835 22.0267 372.539 21.91 372.152 21.91C371.772 21.91 371.472 22.0267 371.252 22.26C371.039 22.4933 370.932 22.8233 370.932 23.25V26.75H370.032ZM377.718 26.83C377.278 26.83 376.898 26.7467 376.578 26.58C376.258 26.4133 376.008 26.1733 375.828 25.86C375.655 25.54 375.568 25.1633 375.568 24.73V23.27C375.568 22.83 375.655 22.4533 375.828 22.14C376.008 21.8267 376.258 21.5867 376.578 21.42C376.898 21.2533 377.278 21.17 377.718 21.17C378.158 21.17 378.538 21.2533 378.858 21.42C379.178 21.5867 379.425 21.8267 379.598 22.14C379.778 22.4533 379.868 22.8267 379.868 23.26V24.73C379.868 25.1633 379.778 25.54 379.598 25.86C379.425 26.1733 379.178 26.4133 378.858 26.58C378.538 26.7467 378.158 26.83 377.718 26.83ZM377.718 26.03C378.111 26.03 378.418 25.92 378.638 25.7C378.858 25.48 378.968 25.1567 378.968 24.73V23.27C378.968 22.8433 378.858 22.52 378.638 22.3C378.418 22.08 378.111 21.97 377.718 21.97C377.331 21.97 377.025 22.08 376.798 22.3C376.578 22.52 376.468 22.8433 376.468 23.27V24.73C376.468 25.1567 376.578 25.48 376.798 25.7C377.025 25.92 377.331 26.03 377.718 26.03ZM383.194 26.85C382.647 26.85 382.204 26.6667 381.864 26.3C381.531 25.9333 381.364 25.4367 381.364 24.81V23.2C381.364 22.5667 381.531 22.0667 381.864 21.7C382.197 21.3333 382.641 21.15 383.194 21.15C383.647 21.15 384.011 21.2733 384.284 21.52C384.557 21.7667 384.694 22.0967 384.694 22.51L384.514 22.3H384.714L384.694 21.05V19.45H385.594V26.75H384.694V25.7H384.514L384.694 25.49C384.694 25.91 384.557 26.2433 384.284 26.49C384.011 26.73 383.647 26.85 383.194 26.85ZM383.494 26.07C383.867 26.07 384.161 25.9533 384.374 25.72C384.587 25.4867 384.694 25.1633 384.694 24.75V23.25C384.694 22.8367 384.587 22.5133 384.374 22.28C384.161 22.0467 383.867 21.93 383.494 21.93C383.114 21.93 382.814 22.0433 382.594 22.27C382.374 22.4967 382.264 22.8233 382.264 23.25V24.75C382.264 25.1767 382.374 25.5033 382.594 25.73C382.814 25.9567 383.114 26.07 383.494 26.07ZM389.3 26.85C388.667 26.85 388.16 26.6633 387.78 26.29C387.4 25.91 387.21 25.3967 387.21 24.75V21.25H388.11V24.75C388.11 25.1633 388.217 25.4867 388.43 25.72C388.643 25.9467 388.933 26.06 389.3 26.06C389.673 26.06 389.967 25.9467 390.18 25.72C390.4 25.4867 390.51 25.1633 390.51 24.75V21.25H391.41V24.75C391.41 25.3967 391.217 25.91 390.83 26.29C390.443 26.6633 389.933 26.85 389.3 26.85ZM395.146 26.85C394.706 26.85 394.32 26.7667 393.986 26.6C393.66 26.4333 393.406 26.1933 393.226 25.88C393.046 25.56 392.956 25.1833 392.956 24.75V23.25C392.956 22.81 393.046 22.4333 393.226 22.12C393.406 21.8067 393.66 21.5667 393.986 21.4C394.32 21.2333 394.706 21.15 395.146 21.15C395.78 21.15 396.29 21.32 396.676 21.66C397.063 22 397.266 22.4633 397.286 23.05H396.386C396.366 22.6967 396.246 22.4267 396.026 22.24C395.813 22.0467 395.52 21.95 395.146 21.95C394.753 21.95 394.44 22.0633 394.206 22.29C393.973 22.51 393.856 22.8267 393.856 23.24V24.75C393.856 25.1633 393.973 25.4833 394.206 25.71C394.44 25.9367 394.753 26.05 395.146 26.05C395.52 26.05 395.813 25.9533 396.026 25.76C396.246 25.5667 396.366 25.2967 396.386 24.95H397.286C397.266 25.5367 397.063 26 396.676 26.34C396.29 26.68 395.78 26.85 395.146 26.85ZM401.502 26.75C401.029 26.75 400.659 26.6233 400.392 26.37C400.132 26.1167 400.002 25.76 400.002 25.3V22.07H398.452V21.25H400.002V19.7H400.902V21.25H403.102V22.07H400.902V25.3C400.902 25.72 401.102 25.93 401.502 25.93H403.002V26.75H401.502ZM404.548 26.75V25.93H406.498V22.07H404.798V21.25H407.398V25.93H409.248V26.75H404.548ZM406.848 20.26C406.628 20.26 406.455 20.2033 406.328 20.09C406.202 19.9767 406.138 19.8233 406.138 19.63C406.138 19.43 406.202 19.2733 406.328 19.16C406.455 19.04 406.628 18.98 406.848 18.98C407.068 18.98 407.242 19.04 407.368 19.16C407.495 19.2733 407.558 19.43 407.558 19.63C407.558 19.8233 407.495 19.9767 407.368 20.09C407.242 20.2033 407.068 20.26 406.848 20.26ZM412.495 26.83C412.055 26.83 411.675 26.7467 411.355 26.58C411.035 26.4133 410.785 26.1733 410.605 25.86C410.431 25.54 410.345 25.1633 410.345 24.73V23.27C410.345 22.83 410.431 22.4533 410.605 22.14C410.785 21.8267 411.035 21.5867 411.355 21.42C411.675 21.2533 412.055 21.17 412.495 21.17C412.935 21.17 413.315 21.2533 413.635 21.42C413.955 21.5867 414.201 21.8267 414.375 22.14C414.555 22.4533 414.645 22.8267 414.645 23.26V24.73C414.645 25.1633 414.555 25.54 414.375 25.86C414.201 26.1733 413.955 26.4133 413.635 26.58C413.315 26.7467 412.935 26.83 412.495 26.83ZM412.495 26.03C412.888 26.03 413.195 25.92 413.415 25.7C413.635 25.48 413.745 25.1567 413.745 24.73V23.27C413.745 22.8433 413.635 22.52 413.415 22.3C413.195 22.08 412.888 21.97 412.495 21.97C412.108 21.97 411.801 22.08 411.575 22.3C411.355 22.52 411.245 22.8433 411.245 23.27V24.73C411.245 25.1567 411.355 25.48 411.575 25.7C411.801 25.92 412.108 26.03 412.495 26.03ZM416.211 26.75V21.25H417.111V22.3H417.301L417.111 22.51C417.111 22.0767 417.241 21.7433 417.501 21.51C417.761 21.27 418.121 21.15 418.581 21.15C419.134 21.15 419.574 21.32 419.901 21.66C420.227 22 420.391 22.4633 420.391 23.05V26.75H419.491V23.15C419.491 22.7567 419.384 22.4567 419.171 22.25C418.964 22.0367 418.681 21.93 418.321 21.93C417.947 21.93 417.651 22.0433 417.431 22.27C417.217 22.4967 417.111 22.8233 417.111 23.25V26.75H416.211Z"
                        fill="white" />
                </svg>

            </div>

            <div class="flex align-center justify-center md:px-16 px-4 w-full max-w-7xl">
                <div class="flex flex-col align-center justify-center gap-8">
                    <div class="op-1 flex flex-col align-center">
                        <h1 class="xl:text-5xl text-3xl font-bold text-white text-center opacity-90 mb-4">Don't just
                            stream it,</h1>
                        <h1 id="head-id" class="xl:text-9xl text-4xl font-extrabold text-white text-center">
                            CAST it LIVE
                        </h1>

                    </div>
                    <div class="op-2">
                        <p
                            class="lg:text-3xl text-xl text-white opacity-70  flex justify-center text-center leading-12 !font-['Montserrat']  montserrat">
                            Fully automate your Live Casting and Content <br>Publishing Workflows with Generative AI.
                        </p>
                    </div>
                    <div class="gap-3 flex justify-center mt-8">
                        <button
                            class="p-3 px-4 bg-primary cursor-pointer text-dark-black mr-4 text-xl rounded-lg border-none"
                            @click="handleButtonClick">Start a Cast >
                        </button>
                        <button class="p-3 px-4 bg-white cursor-pointer text-dark-black text-xl rounded-lg border-none"
                            @click="setActiveModal('subscribeModal')">Subscribe
                        </button>
                    </div>
                </div>
            </div>
        </section>

        <WhatIsDecast></WhatIsDecast>



        <Features></Features>

        <Partners></Partners>

        <Steps></Steps>

        <PostProcessing></PostProcessing>

        <section
            class="max-w-7xl w-full md:px-16 px-4 gap-32 hidden flex-col justify-center items-center mx-auto py-16">

            <div class="grid grid-cols-2 grid-flow-row justify-center items-start w-full h-full gap-16">

                <div class="col-span-1 w-full flex flex-col items-start gap-4 justify-start">
                    <p class="text-primary text-base">//Virtual Events</p>
                    <h4 class="text-4xl font-extrabold text-white">Effortless Event Creation
                    </h4>
                    <p class="font-semibold text-lg text-white opacity-75 w-2/3">Create and manage events while
                        streamlining
                        the process and saving time.</p>

                    <div class="grid grid-cols-2 w-full justify-start items-start gap-4 opacity-50 mt-8">

                        <span class="flex gap-4 justify-start items-center text-white text-lg font-semibold col-span-1">
                            <span class="p-2 bg-white"></span>
                            Multi-Platform Streaming
                        </span>

                        <span class="flex gap-4 justify-start items-center text-white text-lg font-semibold col-span-1">
                            <span class="p-2 bg-white"></span>
                            NFT Airdrops and Rewards
                        </span>

                        <span class="flex gap-4 justify-start items-center text-white text-lg font-semibold col-span-1">
                            <span class="p-2 bg-white"></span>
                            AI-Powered Post Editing
                        </span>

                        <span class="flex gap-4 justify-start items-center text-white text-lg font-semibold col-span-1">
                            <span class="p-2 bg-white"></span>
                            Custom Branding
                        </span>

                    </div>
                </div>

                <div class="col-span-1 w-full flex flex-col gap-4 border-white border-2 border-solid border-opacity-50">
                    <div class="w-full">
                        <img class="w-full h-full object-contain" src="@/assets/images/homepage/events.png" />
                    </div>
                </div>

            </div>

            <div class="grid grid-cols-2 justify-center items-start w-full h-full grid-flow-row gap-16">

                <div class="col-span-1 w-full flex flex-col items-start gap-4 justify-start order-2">
                    <p class="text-primary text-base">//Decentralized Organizations</p>
                    <h4 class="text-4xl font-extrabold text-white">Secure Collaborations & Records
                    </h4>
                    <p class="font-semibold text-lg text-white opacity-75 w-full">Optimize your collaborative
                        workflow with fully personalised rooms with advanced analytics</p>

                    <div class="grid grid-cols-2 w-full justify-start items-start gap-4 opacity-50 mt-8">

                        <span class="flex gap-4 justify-start items-center text-white text-lg font-semibold col-span-1">
                            <span class="p-2 bg-white"></span>
                            Meeting Analytics
                        </span>

                        <span class="flex gap-4 justify-start items-center text-white text-lg font-semibold col-span-1">
                            <span class="p-2 bg-white"></span>
                            Recording Version Control
                        </span>

                        <span class="flex gap-4 justify-start items-center text-white text-lg font-semibold col-span-1">
                            <span class="p-2 bg-white"></span>
                            Access Control
                        </span>

                        <span class="flex gap-4 justify-start items-center text-white text-lg font-semibold col-span-1">
                            <span class="p-2 bg-white"></span>
                            Advanced In-meeting Tools
                        </span>

                    </div>
                </div>

                <div class="col-span-1 w-full flex flex-col gap-4 border-white border-2 border-solid border-opacity-50">
                    <div class="w-full">
                        <img class="w-full h-full object-contain" src="@/assets/images/homepage/records.png" />
                    </div>
                </div>

            </div>
        </section>

        <h1 class="text-center w-full text-white py-8 mt-16">Decast Tools</h1>

        <div
            class="max-w-7xl w-full md:px-16 px-4 gap-8 py-16 grid lg:grid-cols-2 grid-cols-1 grid-flow-row justify-center items-center mx-auto">

            <div
                class="col-span-1 w-full h-full border-white border-solid border-2 border-opacity-25 rounded-2xl lg:p-16 p-8 flex flex-col justify-start items-start gap-4 box-background">
                <p class="text-primary">//Web Extension</p>
                <h2 class="lg:text-4xl text-3xl text-white">
                    Decast Web Extension:</br> Seamless Across Platforms.
                </h2>
                <p class="text-medium text-white opacity-60 montserrat">
                    Streamline your access to meetings and events directly from your browser—no need to visit
                    the Decast website.
                </p>
                <div class="flex lg:flex-row flex-col gap-4 mt-4">
                    <button
                        class="w-fit flex justify-center items-center font-medium px-4 py-2 bg-primary text-black border-none cursor-pointer rounded"
                        @click="handleButtonClickChrome">chrome.download()
                    </button>
                    <button
                        class="w-fit flex justify-center items-center font-medium px-4 py-2 bg-white text-black border-none cursor-pointer rounded"
                        @click="handleButtonClickFirefox">firefox.download()
                    </button>
                </div>

                <div class="flex justify-center items-center h-full w-full relative mt-8 ">
                    <img class="flex justify-center items-center w-full object-contain border-white border-2 border-solid border-opacity-25 rounded-xl overflow-hidden"
                        src="@/assets/images/homepage/extension.png" />
                </div>
            </div>

            <div
                class="col-span-1 w-full h-full border-white border-solid border-2 border-opacity-25 lg:p-16 p-8 flex flex-col justify-start items-start gap-4 box-background rounded-2xl">
                <p class="text-primary">//Node Provider</p>
                <h2 class="lg:text-4xl text-3xl text-white">
                    Decast Node Provider:</br> Earn by Hosting <br> Events.
                </h2>
                <p class="text-medium text-white opacity-60 montserrat">
                    Earn tokens and rewards by hosting large scale event on our decentralized dcast network. Become
                    a
                    node provider today!
                </p>
                <div class="flex lg:flex-row flex-col gap-4 mt-4">
                    <button
                        class="w-fit flex justify-center items-center font-medium px-4 py-2 bg-primary text-black border-none pointer-events-none opacity-25 rounded">node.download()
                    </button>
                    <button
                        class="w-fit flex justify-center items-center font-medium px-4 py-2 bg-white text-black border-none cursor-pointer rounded"
                        @click="setActiveModal('nodeWaitListModal')">waitList.join()
                    </button>
                </div>
                <div class="flex justify-center items-center h-full w-full relative mt-8">
                    <img class="flex justify-center items-center w-full object-contain border-white border-2 border-solid border-opacity-25 rounded-xl"
                        src="@/assets/images/homepage/node.png" />
                </div>
            </div>

        </div>

        <section class="lg:px-16 px-4 py-6 w-full max-w-7xl flex flex-col mb-32">
            <h1 class="text-center text-white py-16">/* FAQs */</h1>
            <div class="w-full">
                <div v-for="(quesObj, index) in faqQuestions" :key="index">
                    <FaqBox :quesObj="quesObj" :index="index" />
                </div>
            </div>
        </section>

        <SubscribeModal v-if="activeModal === 'subscribeModal'" :closeModal="() => setActiveModal('')" />
        <NodeWaitListModal v-if="activeModal === 'nodeWaitListModal'" :closeModal="() => setActiveModal('')" />

        <Footer></Footer>
    </div> -->
</template>

<script>
import Landing from './components/homepage/Landing.vue';
import Footer from './components/homepage/Footer.vue';
import FooterNew from './FooterNew.vue';
import Navbar from './NavbarNew.vue';
import axios from '../axios';
import constants from '../../constant';
import FaqBox from './components/homepage/FaqBox.vue';
import SubscribeModal from './SubscribeModal.vue';
import NodeWaitListModal from './NodeWaitListModal.vue';
import WhatIsDecast from './components/homepage/WhatIsDecast.vue';
import Partners from './components/homepage/Partners.vue';
import Features from './components/homepage/Features.vue';
import Steps from './components/homepage/Steps.vue';
import PostProcessing from './components/homepage/PostProcessing.vue';
import FilledLoader from '@/decast/components/common/FilledLoader.vue';
// import HomePageSlider from './HomePageSlider.vue';

export default {
    name: 'New Landing',
    components: {
        Navbar,
        Landing,
        Footer,
        WhatIsDecast,
        Partners,
        Features,
        PostProcessing,
        Steps,
        FooterNew,
        FaqBox,
        SubscribeModal,
        NodeWaitListModal,
        FilledLoader,
        // HomePageSlider,
    },
    data() {
        return {
            activeModal: '',
            formData: {
                email: '',
            },
            faqQuestions: [
                {
                    ques: "Is there a free trial available?",
                    answer: "Yes, our core services are free to use. However, decentralized storage options like Sia and Swarm may incur additional costs.",
                },
                {
                    ques: "How secure are my meetings and events on Decast?",
                    answer: "Decast prioritizes your security with features like private rooms, password-protected events, and NFT gating to ensure only authorized participants can access your sessions.",
                },
                {
                    ques: "Can I reschedule or edit Cast details later?",
                    answer: "Yes, you can easily reschedule or edit details of any Cast through your event management dashboard.",
                },
                {
                    ques: "Can I access the recordings of my Cast or room sessions?",
                    answer: "Yes, all recordings are securely stored on Decast and decentralized platforms depending upon your event, ensuring they are tamper-proof and available for future access. There are many exciting options available in recordings as well.",
                },
                {
                    ques: "What customization options are available for my events?",
                    answer: "You can fully brand your events with custom logos, colors, NFT Airdrops and unique meeting URLs ensuring a personalized and professional experience.",
                }
            ]
        };
    },
    computed: {
        activeUserInfo() {
            return this.$store.state.AppActiveUser;
        },
        accessToken() {
            return this.$store.state.auth.accessToken;
        },
        loggedIn() {
            return this.$store.state.auth.loggedIn;
        },
    },
    watch: {
        accessToken(newVal) {
            if (newVal) {
                this.$router.push("/dashboard/rooms");
            } else {
                this.$router.push("/v2login");
            }
        },
    },
    created() {
        // Run once on component load also
        if (this.accessToken) {
            this.$router.push("/dashboard/rooms");
        } else {
            this.$router.push("/v2login");
        }
    },
    mounted() {
        window.addEventListener('message', (event) => {
            if (event.data === 'loginSuccess') {
                console.log(this.$store.state.auth.loggedIn, 'loggedIn');
                this.$store.dispatch('auth/fetched');
                this.$acl.change('user');
                this.$store.commit('auth/SET_LOGGEDIN', true);
                this.$router.push('/dashboard');
                this.url = '';
            }
        });
    },
    methods: {
        open() {
            window.open(constants.challengeUri, '_blank', 'width=600,height=600');
            // window.addEventListener('message', this.handleMessage, false);
        },
        // handleMessage(event) {
        //     if (event.data === 'loginSuccess') {
        //         window.location.reload();
        //     }
        // },
        setActiveModal(modalName) {
            this.activeModal = modalName;
        },
        handleButtonClick() {
            const userInfo = localStorage.getItem('userInfo');
            const accessToken = localStorage.getItem('accessToken');
            if (userInfo && accessToken) {
                this.$router.push('/dashboard');
            } else {
                this.open();
            }
        },
        handleButtonClickChrome() {
            window.open('https://chromewebstore.google.com/detail/decast/jbbajkkblcgflieffddpddigiegkodam', '_blank');
        },
        handleButtonClickFirefox() {
            window.open('https://addons.mozilla.org/en-US/firefox/addon/decast/', '_blank');
        },
        async sendMessage() {
            if (
                !this.formData.email
            ) {
                this.$vs.notify({
                    title: 'Error',
                    text: 'Basic fields are mandatory',
                    color: 'danger',
                });
                return;
            }
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailPattern.test(this.formData.email)) {
                this.$vs.notify({
                    title: 'Error',
                    text: 'Incorrect email',
                    color: 'danger',
                });
                return;
            }
            try {
                const response = await axios.post(
                    constants.apiCastUrl + "/api/contact_us/",
                    this.formData
                );
                this.$vs.notify({
                    title: 'Successful',
                    text: 'Response recieved',
                    color: 'success',
                });
                this.resetForm();
            } catch (error) {
                this.$vs.notify({
                    title: 'Error',
                    text: 'Try again',
                    color: 'danger',
                });
                console.error('Error sending message:', error);
            }
        },
        resetForm() {
            this.formData.email = '';
        },
    },
}
</script>

<style scoped>
* {
    font-family: 'JetBrains Mono', monospace !important;
}

#temp-loading-bg {
    width: 100%;
    height: 100%;
    background: #15161F;
    display: block;
    position: absolute;
    z-index: 9999;
    overflow: hidden;
    top: 0;
    /* margin-top: -2rem;
  margin-left: -2rem; */
}

.temp-svg-container {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 10%;
    overflow: hidden;
}

.temp-svg-container svg {
    height: 100px;
    width: 100px;
}

@media only screen and (max-width: 600px) {
    .temp-svg-container {
        width: 25%;
    }
}

.logos {
    overflow: hidden;
    white-space: nowrap;
    position: relative;
}

.logos:before,
.logos:after {
    position: absolute;
    top: 0;
    width: 250px;
    height: 100%;
    content: '';
    /* z-index: 1; */
}

.logos:before {
    left: 0;
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    width: 200px;
    /* Set the fixed width of the gradient */
    background: linear-gradient(to right, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0));
    /* Dark to transparent gradient */
    z-index: 1;
}

.logos:after {
    right: 0;
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    width: 200px;
    /* Set the fixed width of the gradient */
    background: linear-gradient(to left, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0));
    /* Black to transparent gradient */
    z-index: 1;
}

.logos:hover .logos-slide {
    animation-play-state: paused;
    animation-play-state: paused;
}

.box-border {
    border: 1px solid #636363;
}

.cont-left {
    border: 1px solid #636363;
}

.cont-right {
    border: 1px solid #636363;
}

.hp-main {
    height: calc(100vh - 84px);
}

.bg-gradient {
    background-image: url('../assets/images/homepage/homepage-gradient.svg');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
}

@keyframes logos {
    from {
        transform: translateX(0);
    }

    from {
        transform: translateX(0);
    }

    to {
        transform: translateX(-100%);
    }
}

@keyframes logos2 {
    from {
        transform: translateX(-100%);
    }

    from {
        transform: translateX(-100%);
    }

    to {
        transform: translateX(0);
    }
}

.logos-slide {
    display: inline-block;
    animation: 30s logos infinite linear;
    margin: auto;
}

.logos-slide img {
    margin: auto 40px;
    height: 50px !important;
    width: auto;
    object-fit: contain;
}

.logos-slide2 {
    display: inline-block;
    animation: 20s logos2 infinite linear;
    margin: auto;
}

.logos-slide2 img {
    margin: auto 40px;
    height: 40px !important;
    width: auto;
    object-fit: contain;
}

.parent_landing {
    /* background-image: linear-gradient(180deg, #000, #111); */
    background-color: #000000
}

.basic_home_head__ {
    border: 1px solid white;
}

.basic_home_head__ div:nth-child(1) {
    justify-content: space-between !important;
    height: 320px !important;
    /* border: 1px solid red; */
}

.cast_start_btn_ {
    border: 1px solid black;
    box-shadow: 3px 3px 0px 0px #fff;
}

.home-cont {
    background-image: url("../assets/images/white-box-up.svg");
    background-position: bottom;
    background-size: contain;
    background-repeat: no-repeat;
    padding-bottom: 10vh;
}

.basic_folder_cont__ {
    background-image: url("../assets/images/white-box-down.svg");
    background-position: top;
    background-size: contain;
    background-repeat: no-repeat;
    margin: -2px;
}

.basic_child_folder_ {
    border: 1px solid white;
}

.grid-container {
    display: grid;
    column-gap: 25px;
    row-gap: 25px;
    grid-template-columns: repeat(3, 1fr);
}

.basic_event_cont_ {
    border: 1px solid white;
}

.hm-action-btn-1 {
    border: none;
    outline: none;
    color: #000000;
    background-color: #D7DF23;
    padding: 8px 10px;
    font-weight: 600;
    cursor: pointer;
}

.hm-action-btn-2 {
    border: none;
    outline: none;
    color: #000000;
    background-color: #FFFFFF;
    padding: 8px 10px;
    font-weight: 600;
    cursor: pointer;
}

.box-header {
    height: 16px;
    width: 100%;
    display: flex;
}

.grad-1 {
    height: 20px;
    width: 100%;
    background-color: #7C7C7C;
}

.grad-2 {
    height: 20px;
    width: 34px;
    background-color: #7C7C7C;
}

.box-wrapper {
    border: 1px solid #FFFFFF;
    margin-top: 12px;
    -webkit-box-shadow: 10px 10px 0px 0px rgba(255, 255, 255, 1) !important;
    box-shadow: 10px 10px 0px 0px rgba(255, 255, 255, 1) !important;
}

.text-color-primary {
    color: #D7DF23;
}

.feature-card {
    border: 1px solid #636363;

}
</style>